import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percent'
})
export class PercentPipe implements PipeTransform {

  transform(value: any): any {
    let percent = '0%';
    if(value){
      percent = `${((value * 2) * 10).toFixed(2).toString()}%`;
    }
    return percent;
  }

}
